import React, { Component } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Button,
  ListGroup,
  ListGroupItem
} from 'reactstrap';

class SelectBusiness extends Component {
  constructor(props) {
    super(props);
    this.state = {
      businesses: []
    };
  }

  componentDidMount() {
    fetch('/api/unifying_factors/businesses').then((resp) => resp.json())
      .then((respJson) => {
        this.setState({ businesses: respJson });
      });
  }

  render() {
    const { businesses } = this.state;

    const businessListItems = businesses.map((business, i) => {
      return (
        <ListGroupItem className="d-flex justify-content-between align-items-center" key={i}>
          <span>{business.name}</span>
          <Button
            tag="a"
            href={'/discover_unifying_factors/business/' + business.name}
            color="primary"
            size="sm"
            className="sl-inline-action"
            outline>
            Select
          </Button>
        </ListGroupItem>
      );
    });

    return (
      <Container fluid={true} className="sl-view-shell">
        <div className="sl-view-hero">
          <div>
            <div className="sl-view-kicker">Discover Unifying Factors</div>
            <h1 className="sl-view-title">Select A Business</h1>
            <p className="sl-view-subtitle">Choose a company to compare footprint and market concentration across prefectures.</p>
          </div>
          <span className="sl-view-meta">Step 1 of 3</span>
        </div>

        <Row>
          <Col md="12">
            <Card className="mb-0 sl-panel">
              <CardHeader className="sl-panel-header">
                Select a business with locations in China
              </CardHeader>
              <CardBody>
                <ListGroup>
                  {businessListItems}
                </ListGroup>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default SelectBusiness;
